<template>
  <div class="card">
    <DataTable
      :value="tableData"
      :rows="rows"
      :paginator="true"
      :loading="isLoading"
      :rowsPerPageOptions="rowsPerPageOptions"
      v-model:selection="selectedCodes"
      lazy
      @page="onPaginate"
      :currentPage="currentPage"
      :totalRecords="totalRecords"
    >
      <template #header>
          <div class="flex w-full">
              <div class="flex flex-col">
                  <div class="flex w-full ">
                      <div class="flex justify-start">
                          <FormKit type="form" #default="{ state: { valid } }" :actions="false">
                              <p class="mb-4">Filtrer par date de validité.</p>
                              <div class=" mx-auto mb-4">
                                  <div class="flex grid-cols-1 md:grid-cols-3 gap-1">
                                      <FormKit
                                          type="datepicker"
                                          name="availabilityStartDate"
                                          label="Date de début"
                                          validation="checkDatesIntervalRules"
                                          :validation-rules="{ checkDatesIntervalRules }"
                                          :validation-messages="{
                        checkDatesIntervalRules: 'La date de début doit être inférieur ou égale à la date de fin.',
                      }"
                                          validation-visibility="live"
                                          format="DD/MM/YYYY"
                                          value-format="YYYY-MM-DD"
                                          v-model="availabilityStartDate"
                                          clearable
                                      />

                                      <FormKit
                                          type="datepicker"
                                          name="availabilityEndDate"
                                          label="Date de fin"
                                          validation="checkDatesIntervalRules"
                                          :validation-rules="{ checkDatesIntervalRules }"
                                          :validation-messages="{
                            checkDatesIntervalRules: 'La date de fin doit être supérieure ou égale à la date de début.',
                          }"
                                          validation-visibility="live"
                                          format="DD/MM/YYYY"
                                          value-format="YYYY-MM-DD"
                                          v-model="availabilityEndDate"
                                          clearable

                                      />
                                      <div class="flex items-end">
                                          <FormKit
                                              type="button"
                                              label="Filtrer"
                                              :class="{ 'btn-secondary': true, 'btn-block': true }"
                                              @click="filterAvailableDocumentsByExpirationDate"
                                              :disabled="!valid || isLoading"
                                          />
                                      </div>
                                  </div>
                              </div>

                          </FormKit>
                      </div>
                  </div>
                  <div class="card-toolbar w-full row">
              <span class="p-input-icon-left ">
              <i class="pi pi-search" />
              <InputText
                  v-model="codeNameModel"
                  placeholder="Rechercher un code"
                  @keyup.enter="onFilterDt"
              />
            </span>
                      <span class="p-input-icon-left ml-4 mr-3">
              <i class="pi pi-search" />
              <InputText
                  v-model="productNameModel"
                  placeholder="Rechercher par produit"
                  @keyup.enter="onFilterDt"
              />
            </span>
                      <span class="p-input-icon-left">
                    <FormKit
                        type="autocomplete"
                        name="supplier"
                        placeholder="Sélectionner un fournisseur"
                        :options="searchSuppliers"
                        v-model="supplierModel"
                    />
                </span>

                  </div>
                  
              </div>
              <div class="flex flex-col items-end justify-end ml-auto  ">
                  <div class="flex w-full justify-end ml-auto">
                      <Button size="small" class="btn btn-primary p-2 ps-2 pe-2 justify-end ml-auto" style="margin-bottom: 0.5em;" title="Désactiver la liste des Codes"
                              @click="disableGroupAction(selectedCodes)">
                          Désactiver la liste des Codes
                      </Button>
                  </div>

                  <div class="w-full">
                      <p>Nombre de ligne sélectionnée(s) : {{ selectedCodes.length }} Code(s)</p>
                  </div>
              </div>


          </div>


         
      </template>
      <div class="card-body pt-0">
        <Column selectionMode="multiple"></Column>
        <Column field="code" header="Code" />
        <Column field="productName" header="Nom du produit" />
        <Column field="productType" header="Type de produit" />
        <Column field="supplierName" header="Fournisseur" />
        <Column field="expirationDate" header="Expiration"/>
      </div>
      <template #empty>Aucun résultat trouvé.</template>
    </DataTable>
  </div>
</template>
<script setup lang="ts">
import Column from "primevue/column";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import DataTable from "primevue/datatable";
import {ref, onMounted, watch} from "vue";
import { fetchCodesAvailable } from "@/_services/code/code";
import { Code } from "@/models/product/code/Code";
import swal from "@/_helpers/swal";
import { getLocalStorageRowsPerPage, setLocalStorageRowsPerPage } from "@/_services/localStorage.service";
import ApiService from "@/_services/api.service";
import moment from "moment";

const isLoading = ref<boolean>(true);
const codes = Array<Code>();
const tableData = ref<Array<Code>>(codes);
const localStorageKey = "selectedCodes";
const selectedCodes = ref(Array<Code>());
const availabilityStartDate = ref<string>('');
const availabilityEndDate = ref<string>('');

const rows = ref<number>(10);
const defaultRowsPerPage = 10;
const rowsPerPageOptions = [defaultRowsPerPage, 25, 100];
const codeNameModel = ref<string>("");
const totalRecords = ref<number>(0);
const page = ref<number>(1);
const currentPage = ref<number>(0);
let supplierModel = ref('');
let productNameModel = ref('');
async function populateDatatable() {
    let paramsFilter = {
        name: codeNameModel.value,
        supplier:supplierModel.value,
        productName: productNameModel.value,
        availabilityStartDate: availabilityStartDate.value,
        availabilityEndDate: availabilityEndDate.value,
    };
  const [loadingDt,totalRecordsDt, tableDataDt] = await fetchCodesAvailable(rows.value, page.value, paramsFilter);
  isLoading.value = loadingDt;
  tableData.value = tableDataDt;
  totalRecords.value = totalRecordsDt;
}

watch([availabilityStartDate, availabilityEndDate],
    ([newAvailabilityStartDate, newAvailabilityEndDate], [prevAvailabilityStartDate, prevAvailabilityEndDate]) => {
    if ((newAvailabilityStartDate === '' || newAvailabilityStartDate === undefined)
        && (newAvailabilityEndDate === '' || newAvailabilityEndDate === undefined)
        && productNameModel.value === ""
        && codeNameModel.value === ""
    ) {
        clearDtSelectedCode();
    }
});

const onPaginate = async (e) => {
    rows.value = e.rows;
    currentPage.value = e.page;
    page.value = e.page + 1;
    populateDatatable();
};

const onFilterDt = () => {
    if (productNameModel.value === ""
        && codeNameModel.value === ""
        && isAvailabilityStartDateEmpty()
        && isAvailabilityEndDateEmpty()
    ) {
        clearDtSelectedCode();
    }
    
    rows.value = 10;
    page.value = 1;
    populateDatatable();
};

onMounted(async () => {
  await populateDatatable();
  setLocalStorageRowsPerPage(rows.value, localStorageKey);
});

function disableGroupAction(selectedCodes){
  selectedCodes.length <= 0
    ? swal.warning("Veuillez selectionner au moins un code")
    :
    swal
      .confirm(
        `Êtes-vous sûr de vouloir désactiver  les (${selectedCodes.length}) Code(s) ?`
      )
      .then((result) => {
        if (result.isConfirmed) {
          disableGroupCodes(selectedCodes);
        }else {
          window.location.reload();
        }
      });
}

async function disableGroupCodes(selectedCodes) {
  const uuidArray = getSelectedCodeUuids(selectedCodes);

  const dataToSendToApi = {
    codes: uuidArray,
  };

  await ApiService.patchWithoutSlug("disable_product_codes", dataToSendToApi)
    .then(() => {
      swal.info(`Vous venez de désactiver les codes.`).then(() => {
        window.location.reload();
      });
    })
    .catch(() => {
      swal.error().then(() => {
        window.location.reload();
      });
    });
}

function getSelectedCodeUuids(selectedCodes) {
  return selectedCodes.map((code) => code.uuid);
}
async function searchSuppliers({search}) {
    if (!search || search.length < 3) return [];
    const fetchSuppliers = await ApiService.get(`suppliers?name=${search || ''}&isActive=true`);
    return fetchSuppliers.data.data.map((val: any) => {
        return {
            label: val.name,
            value: val.uuid
        }
    });
}

const checkDatesIntervalRules = (node: any) => {
    const selectedDate = node.value;
    if (typeof availabilityStartDate.value !== 'undefined' && typeof availabilityEndDate.value !== 'undefined') {
        return moment(availabilityStartDate.value).isSameOrBefore(availabilityEndDate.value);
    }

    return true;
}

const filterAvailableDocumentsByExpirationDate = async () => {
    isLoading.value = true;
    try {
        await populateDatatable();
    } catch (error) {
        swal.error("Erreur lors de la recherche par date d'expiration");
    } finally {
        isLoading.value = false;
    }
}

const clearDtSelectedCode = () => {
    selectedCodes.value = [];
};

const isAvailabilityStartDateEmpty = (): boolean => {
    return availabilityStartDate.value === "" || availabilityStartDate.value === undefined;
}

const isAvailabilityEndDateEmpty = (): boolean => {
    return availabilityEndDate.value === "" || availabilityEndDate.value === undefined;
}

</script>